import React, { Suspense } from 'react';
import { Outlet } from "react-router-dom";
import {Header} from './components/ActoLoan/Header';
import Footer from './components/ActoLoan/Footer';
import FraudAlertMarquee from './components/FraudAlertMarquee';
import './css/Common.css'



function Layout() {
  return (
    <div className="wrapper" style={{ paddingBottom: '42px' }}>
    <div id="snackbar"></div>
    <FraudAlertMarquee />
    <header className="">
      {/* <TopContactBar /> */}
      <Header />
    </header>
    <main className="">
     <Suspense fallback={<div className="loading-fallback-bar" />}>
      <Outlet />  
     </Suspense>
    </main>
    <div className="float_content">
 
</div>

    <footer className="">
      <Footer />
    </footer>
  </div>
  )
}

export default Layout;